__turbopack_context__.v({
  "btn": "accessories-item-module-scss-module__rqQalq__btn",
  "card": "accessories-item-module-scss-module__rqQalq__card",
  "img": "accessories-item-module-scss-module__rqQalq__img",
  "price": "accessories-item-module-scss-module__rqQalq__price",
  "textWrapper": "accessories-item-module-scss-module__rqQalq__textWrapper",
  "title": "accessories-item-module-scss-module__rqQalq__title",
});
